// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 884 ? "wz2025-codes" : chunkId) + "." + {"158":"5eee27a1","245":"ba1f1254","262":"4c02ba8e","280":"217f76c0","287":"1c51975b","453":"feb0ea4f","801":"9a59f219","884":"63346a16"}[chunkId] + ".chunk.js";
};